<script setup>
definePage({
  meta: {
    action: 'read',
    subject: 'subject',
    navActiveLink: 'subjects',
  },
})

import { useSnackBar } from '@/utils/stores/snackbar'
import SubjectList from "@/views/subjectsV2/view/subjectList.vue"
import TabIndex from "@/views/subjectsV2/view/tabIndex.vue"

// subject list 에서 선택한 subject로 tabindex에 넣어준다.
// tabindex -> title에 넣고 id를 또 내려줌.

const snackbarStore = useSnackBar()
const selectedSubject = ref({})
const isReadonly = computed(() => !!selectedSubject.value.deleted)

const selectSubject = value => {
  selectedSubject.value = value
}

const onSubjectUpdated = ({ subjectId, status }) => {
  if (selectedSubject.value.id === subjectId) {
    selectedSubject.value = { ...selectedSubject.value, status }
  }
}

onMounted(() => {
  snackbarStore.showSnackBar("각 아이콘을 누르면 기록 입력화면으로 이동합니다.")
})
</script>

<template>
  <VAlert
    v-if="isReadonly"
    type="info"
    variant="tonal"
    class="mb-4"
  >
    중도탈락된 검체입니다. 읽기 전용 모드로 표시됩니다.
  </VAlert>
  <VRow>
    <VCol cols="12">
      <!-- SchedulePanel.vue -->
      <VRow class="gap-1 vrow-no">
        <!-- Left: Sidebar Card -->
        <VCol
          cols="12"
          md="3"
          lg="2"
          style="max-inline-size:260px"
        >
          <VCard class="side-card">
            <VCardTitle class="py-3 px-4">
              동물(검체) 이름
            </VCardTitle>
            <VDivider />
            <VCardText class="p-0">
              <SubjectList @select-subject="selectSubject" />
            </VCardText>
          </VCard>
        </VCol>

        <!-- Right: Main Content Card -->
        <VCol
          cols="12"
          md="9"
          lg="10"
        >
          <VCard class="main-card">
            <VCardText class="px-4 py-3">
              <TabIndex
                :selected-subject="selectedSubject"
                :readonly="isReadonly"
                @subject-updated="onSubjectUpdated"
              />
            </VCardText>
          </VCard>
        </VCol>
      </VRow>
    </VCol>
  </VRow>
</template>

<style lang="scss" scoped>
.vrow-no{
  flex-wrap: nowrap !important;
}

/* <style scoped> 또는 전역 SCSS */
.side-card,
.main-card {
  border: 1px solid rgba(0,0,0,6%);
  border-radius: 16px;
  background: rgb(var(--v-theme-surface));
  box-shadow: 0 4px 18px rgba(22, 28, 45, 8%);
}

.side-card {
  position: sticky;
  display: flex;
  flex-direction: column;
  align-self: flex-start;
  inset-block-start: 88px;           /* 헤더 높이에 맞게 조정 */
  max-block-size: calc(100vh - 120px);

  .v-card-text {
    overflow: auto;    /* 목록 길어질 때 스크롤 */
    padding: 0 !important;
  }
}

@media (max-width: 960px) {
  .side-card {
    position: static;
    max-block-size: none;
  }
}
</style>
